/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * How stakes and prizes work for this competition
 * @export
 */
export const CompetitionEntryType = {
    FREE: 'FREE',
    ENTRY_FEE: 'ENTRY_FEE',
    SPONSORED: 'SPONSORED',
    PRIZE_POOL: 'PRIZE_POOL',
    CHARITY: 'CHARITY'
} as const;
export type CompetitionEntryType = typeof CompetitionEntryType[keyof typeof CompetitionEntryType];


export function instanceOfCompetitionEntryType(value: any): boolean {
    for (const key in CompetitionEntryType) {
        if (Object.prototype.hasOwnProperty.call(CompetitionEntryType, key)) {
            if (CompetitionEntryType[key as keyof typeof CompetitionEntryType] === value) {
                return true;
            }
        }
    }
    return false;
}

export function CompetitionEntryTypeFromJSON(json: any): CompetitionEntryType {
    return CompetitionEntryTypeFromJSONTyped(json, false);
}

export function CompetitionEntryTypeFromJSONTyped(json: any, ignoreDiscriminator: boolean): CompetitionEntryType {
    return json as CompetitionEntryType;
}

export function CompetitionEntryTypeToJSON(value?: CompetitionEntryType | null): any {
    return value as any;
}

export function CompetitionEntryTypeToJSONTyped(value: any, ignoreDiscriminator: boolean): CompetitionEntryType {
    return value as CompetitionEntryType;
}

